import { FC, Children, PropsWithChildren, useMemo, memo } from "react";
import Link, { LinkProps } from "next/link";
import classnames from "classnames";
import { useSearchParams } from "next/navigation";
import { usePathnameWithLocal } from "hooks";

interface IProps {
    activeClassName: string;
    includes?: string;
    forceActive?: boolean;
}

const ActiveLink: FC<PropsWithChildren<IProps & LinkProps & { className?: string }>> = ({
    children,
    activeClassName,
    includes,
    forceActive,
    href,
    className,
    ...props
}) => {
    const { pathnameWithoutLocale: path } = usePathnameWithLocal();
    const searchParams = useSearchParams();
    const child = Children.only(children);

    // Check if includes is in path or in any query param value
    const matchesQuery = includes
        ? Array.from(searchParams.values()).some((v) => v === includes)
        : false;

    const isActive = useMemo(
        () =>
            forceActive ||
            (includes && (path?.includes(includes) || matchesQuery)) ||
            path ===
                (typeof href === "string" ? href : href.pathname !== "/" ? href.pathname : false),
        [forceActive, path, href, includes, matchesQuery],
    );

    return (
        <Link
            href={href}
            className={classnames(className, isActive && ["activeLink", activeClassName])}
            {...props}>
            {child}
        </Link>
    );
};

export default memo(ActiveLink);
